// Convert bikes images from qwic.nl to thumbnail size
export const convertImageToThumbnail = (qwicImageUrl: string) => {
    return qwicImageUrl.replace(/\.(\w+)$/, '-400x275.$1');
};

// Convert bikes images from qwic.nl to large size
export const convertImageToLarge = (qwicImageUrl: string) => {
    return qwicImageUrl.replace(/\.(\w+)$/, '-1140x784.$1');
};
